import { render } from "./Select.vue?vue&type=template&id=ed6a05a8"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed6a05a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed6a05a8', __exports__)) {
    api.reload('ed6a05a8', __exports__)
  }
  
  module.hot.accept("./Select.vue?vue&type=template&id=ed6a05a8", () => {
    api.rerender('ed6a05a8', render)
  })

}


export default __exports__